<template>
  <div>
    <div class="page-header">
      <span class="h3">{{ $t("tags.singular") }} Archive</span>
      <router-link :to="$t('tags.route')"><span class="h6 text-muted float-right">All {{ $t("tags.plural") }}</span></router-link>
    </div>

    <ul class="mt-2 list-group">
      <draggable v-model="allTags" @start="drag=true" @end="drag=false" handle=".sort-handle">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="tag in allTags" :key="tag.id" class="list-group-item">
            <TagTitle :tag=tag />
          </li>
        </transition-group>
      </draggable>
    </ul>
  </div>
</template>

<script>
var firstBy = require('thenby');
import api from "api";
import QuickTask from "components/QuickTask";
import TagTitle from "components/TagTitle";
import NewQuickTask from "components/NewQuickTask";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import draggable from 'vuedraggable'

export default {
  components: {
    QuickTask,
    NewQuickTask,
    TagTitle,
    Loading,
    draggable
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    allTags: {
      set: function(value){
        var ordered_ids = []
        value.forEach(function(item, index){
          ordered_ids.push(item.id)
        })

        var payload = {
          name: 'archived_tags',
          ordered_ids: ordered_ids
        }
        store.commit('updateSortedGroup', payload)

        return value;

      },
      get: function(){
        return store.getters.sortedArchivedTags
      }
    }
  }
};
</script>
